import { VOICEMAIL_ERRORS } from "../../../common/constants/agentModule/voiceMailConstants";
import { VOICEMAIL_URLS } from "../../apiConfig";
import apiClient from "../../apiInstance";

export const getPendingVoiceMail = async (connectionType, status) => {
    try {
      const response = await apiClient.post(VOICEMAIL_URLS.GET_PENDING_VOICEMAIL, {
        connectionType, status
      });
      return response.data;
    } catch (error) {
      console.error(VOICEMAIL_ERRORS.FETCH_PENDING_VOICEMAIL_ERROR, error);
      throw error;
    }
  };